import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { QuickbetModule } from '../quickbet/quickbet.module';
import { SharedModule } from '../shared/shared.module';
import { SrmQuickbetComponent } from './components/quickbet/srm-quickbet.component';
import { SrmQuickbetPanelUpdatedComponent } from './components/quickbetPanelUpdated/srm-quickbet-panel-updated.component';
import { SrmQuickbetPanelWrapperComponent } from './components/quickbetPanelWrapper/srm-quickbet-panel-wrapper.component';
import { SrmQuickbetPartialOverlayComponent } from './components/quickbetPartialOverlay/srm-quickbet-partial-overlay.component';
import { SrmQuickbetPartialOverlaySelectionComponent } from './components/quickbetPartialOverlaySelection/srm-quickbet-partial-overlay-selection.component';
import { SrmQuickbetReceiptComponent } from './components/quickbetReceipt/srm-quickbet-receipt.component';
import { SrmQuickbetSelectionComponent } from './components/quickbetSelection/srm-quickbet-selection.component';

@NgModule({
    imports: [SharedModule, FormsModule, QuickbetModule],
    declarations: [
        SrmQuickbetPanelWrapperComponent,
        SrmQuickbetComponent,
        SrmQuickbetSelectionComponent,
        SrmQuickbetReceiptComponent,
        SrmQuickbetPanelUpdatedComponent,
        SrmQuickbetPartialOverlayComponent,
        SrmQuickbetPartialOverlaySelectionComponent,
    ],
    exports: [SrmQuickbetPanelWrapperComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class SrmQuickbetModule {}
